import { LazyLoadWrapper } from "features/Common/LazyLoadWrapper/LazyLoadWrapper";
import { AccessTypePurchaseModal } from "features/MySubscriptions/constants/MySubscriptions.lazy";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import React from "react";
import { useAccessTypePlanModalWrapper } from "./hooks/useAccessTypePlanModalWrapper";

export const AccessTypePlanModalWrapper = withComponentLibraryTheme(() => {
  const {
    showPlansModal,
    closeAccessTypePlansModal,
    accessTypePlans,
    accessTypePlansFeatureKey,
    modalTitle,
  } = useAccessTypePlanModalWrapper();

  return (
    <LazyLoadWrapper loadingCondition={showPlansModal}>
      <AccessTypePurchaseModal
        open={showPlansModal}
        onClose={closeAccessTypePlansModal}
        plans={accessTypePlans}
        featureKey={accessTypePlansFeatureKey}
        modalTitle={modalTitle}
        redirectToCartPage
      />
    </LazyLoadWrapper>
  );
});
